import { lt, FormSelectField } from '@mews/framework';
import { SELECT_EMPTY_VALUE, SelectFieldProps } from '@mews-commander/form';
import { UnicodeEntity } from '@mews/enums';
import { DropdownItem } from '@optimus-web/core';
import { TaxConfiguration } from '../../../../hooks/useConfigureProductTax';
import { TaxesFieldNames } from '../../formEnums';

interface Props {
    code: string;
    environmentCode: string;
    inline?: boolean;
    searchTaxRates: SelectFieldProps['customSearch'];
    taxRates: TaxConfiguration['taxRates'];
}

export const TaxRateSelectField = ({ code, environmentCode, inline, searchTaxRates, taxRates }: Props) => (
    <FormSelectField
        customSearch={searchTaxRates}
        defaultValue={SELECT_EMPTY_VALUE}
        inline={inline}
        label={lt('ConfigureProductDropdownTaxRate')}
        name={`${TaxesFieldNames.TaxEnvironmentCode}.${environmentCode}.${TaxesFieldNames.TaxRate}.${code}`}
        required
        suffix={taxRates[0].currency}
    >
        <DropdownItem
            data-test-select-item-value={SELECT_EMPTY_VALUE}
            value={SELECT_EMPTY_VALUE}
            label={UnicodeEntity.Dash}
        />
        {taxRates.map(({ code: taxRateCode, primaryText }) => (
            <DropdownItem key={taxRateCode} label={primaryText} value={taxRateCode} />
        ))}
    </FormSelectField>
);
